var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactusGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 38.9",
    style: {
      enableBackground: "new 0 0 40 38.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "forum_00000171705972475376779380000002647805944019888538_",
    gradientUnits: "userSpaceOnUse",
    x1: -505.5257,
    y1: 546.6273,
    x2: -505.5257,
    y2: 545.6273,
    gradientTransform: "matrix(40.0022 0 0 -38.8852 20242.1465 21255.7148)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9E021"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009245"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "forum",
    style: {
      fill: "url(#forum_00000171705972475376779380000002647805944019888538_)"
    },
    d: "M0,28.2V2.1 c0-0.5,0.3-1,0.7-1.4C1,0.3,1.5,0,2,0h26c0.5,0,1,0.3,1.4,0.7C29.7,1,30,1.6,30,2.1v17.8c0,0.5-0.3,1-0.7,1.4 C29,21.7,28.5,22,27.9,22H8l-6.7,6.7c-0.2,0.2-0.5,0.3-0.8,0.2C0.2,28.8,0,28.5,0,28.2z M3,3L3,3z M10.1,32c-0.5,0-1-0.3-1.4-0.7 C8.3,30.9,8,30.4,8,29.9V25h25V8h5c0.5,0,1,0.3,1.3,0.7c0.4,0.4,0.6,0.9,0.7,1.4v28c0,0.3-0.2,0.6-0.5,0.7c-0.3,0.1-0.6,0.1-0.8-0.2 L32,32H10.1z M27,3H3v16h24V3z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactusGreen);
export default __webpack_public_path__ + "static/media/contactus_green.8ae85f16a18f20249986d0c3c7116da5.svg";
export { ForwardRef as ReactComponent };